require('./_wks-define')('asyncIterator');


//////////////////
// WEBPACK FOOTER
// /var/www/umem/~/core-js/modules/es7.symbol.async-iterator.js
// module id = 258
// module chunks = 0